import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "submit"]

  connect() {
    this.update()
  }

  update() {
    const direction = this.element.querySelector('input[name="phone_call[direction]"]:checked')?.value || "outgoing"
    const outcome = this.element.querySelector('input[name="phone_call[outcome]"]:checked')?.value
    this.labelTargets.forEach(label => { label.textContent = label.dataset[direction] })
    this.submitTargets.forEach(label => { label.textContent = outcome === "texted" ? "Log text" : "Log call" })
  }
}
